import React, {Component} from 'react';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';

import IPut from './iput/src/index';
import CidrInput from './iput/src/CidrInput';
import WildcardInut from './iput/src/WildcardInput';
import UrlInput from './iput/src/UrlInput';
import ToInput from './iput/src/ToInput';


import { getNotation } from './iput/src/helper';



export default class HostsInput extends React.Component{
    constructor(props){
        super(props);

        this.Format = this.Format.bind(this);
    }
    Format(props) {
        const {my, children, format, ...other } = props;
      
        return (
          <Typography style={{height:'100%'}}
            component="div"
            role="tabpanel"
            hidden={my !== format}
            id={`simple-tabpanel-${format}`}
            aria-labelledby={`simple-tab-${format}`}
            {...other}
          >
             <Grid container justify='center' spacing={3}
                    alignItems='center' style={{height:'100px'}}>
                        {children}
            </Grid>
          </Typography>
        );
    }
    render() {
        var {format, value,onChange } = this.props;
        var from, to;
        if (value) {
            format = format? format : getNotation(value);
            if (format === 'Single' || format === 'URL') {
                from = value;
            } else if (format === 'From To') {
                if (value) {
                    const ss = value.split('-');
                    from = ss[0];
                    to = ss[1];
                }
            }
        } else if (!format) {
            format = 'Single';
        }

        return(
            <div style={{height:'100px',width:'100%'}}>
                <this.Format my='Single' format={format}>
                    <Chip label='Single IP' color='primary' />
                    <IPut style={{ margin: 'auto' }} onChange={p => onChange(format,p)} />
                </this.Format>
                <this.Format my='From To' format={format}>
                    <Chip label='From' color='primary' />
                    <IPut onChange={p => onChange(format,`${p}-${to}`)} />
                    <Chip label='To' color='primary' />
                    <ToInput onChange={p => onChange(format,`${from}-${p}`)} />
                </this.Format>
                <this.Format my='CIDR' format={format}>
                        <IPut onChange={this.onFromChange}/>
                        <Chip label='/' color='primary'/>
                        <CidrInput onChange={this.onCidrChange}/>
                </this.Format>
                <this.Format my='MASK' format={format}>
                        <IPut key='m' onChange={this.onFromChange}/>
                        <Chip label='/' color='primary'/>
                        <IPut key='n' onChange={this.onMaskChange}/>
                </this.Format>
                <this.Format my='Wildcard' format={format}>
                        <WildcardInut onChange={this.onWildcardChange}/>
                </this.Format>
                <this.Format my='URL' format={format}>
                    <Chip label='URL' color='primary' />
                    <UrlInput onChange={p => onChange(format, p)} />
                </this.Format>
            </div>
        );
    }
}